import {
    extractProperties,
    isEmpty,
} from './'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatMessageUpdatedEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const messageUpdated: CaseReducer<NinchatState> = (state, action) => {
    const {
        channel_id,
        message_deleted,
        message_hidden,
        message_id,
        user_id,
        ...rest
    } = extractProperties<NinchatMessageUpdatedEvent>(action.payload)

    isEmpty(rest)

    const chatId = channel_id ?? user_id

    if (chatId) {
        const message = state._messages[chatId].messages.find((m) => m.message_id === message_id)

        if (message) {
            message._revision = Date.now()
            message.message_deleted = message_deleted ?? message.message_deleted
            message.message_hidden = message_hidden ?? message.message_hidden
        }
    }
}
